import { omit } from 'lodash';
import { normalizeOne } from '~/utils/api/normalizers';
import { serializeOne } from '~/utils/api/serializers';

import {
  authorizedInstance as Rb,
} from '~/utils';

const getAll = (url, options = {}) =>
  Rb
    .get(url, { params: options })
    .then(r => r.data.data)
    .then(r => r.map(normalizeOne));

const getOne = (url, options = {}) =>
  Rb
    .get(url, { params: options })
    .then(r => r.data.data)
    .then(normalizeOne);

const post = (url, v, options = {}) =>
  Rb.post(url, serializeOne(v), { params: options });

const put = (url, v, options = {}) => {
  const params = omit('id', options);

  return Rb.put(url, serializeOne(v), { params });
};

const destroy = (url, options = {}) =>
  Rb.delete(url, { params: options });

// any thrown error from below will be in a warning because of formik
// https://github.com/jaredpalmer/formik/issues/1636
const buildURL = (url, options = {}) => {
  const patientRegex = /(\[patient_uid\])/gi;
  const mvRegex = /(\[mv\])/gi;

  if (url.match(patientRegex) && options.patient) {
    return url.replace(patientRegex, options.patient);
  } else if (url.match(patientRegex) && !options.patient) {
    throw new Error('No patient uid to replace `[patient_uid]` with. ex: `{ patient: \'patient_uid\' }`');
  } else if (url.match(mvRegex)) {
    return url.replace(mvRegex, options.summary ? '/mv' : '');
  }

  return url;
};

const factory = (url, opts = {}) => {
  const {
    serializeOne: moduleSerializer = v => v,
    normalizeOne: moduleNormalizer = v => v,
    ...options
  } = opts;

  return {
    getAll: (o) =>
      getAll(
        buildURL(url, o),
        options,
      )
        .then(r =>
          r.map(moduleNormalizer)),

    getOne: (id, o) =>
      getOne(
        buildURL(`${url}/${id}`, o),
        options,
      )
        .then(moduleNormalizer),

    post: ({ values, options: o }) =>
      post(
        buildURL(url, o),
        moduleSerializer(values),
        options,
      )
        .then(moduleNormalizer),

    put: ({ values, id, options: o }) =>
      put(
        buildURL(`${url}/${id}`, o),
        moduleSerializer(values),
        options,
      )
        .then(moduleNormalizer),

    delete: (id, o) =>
      destroy(
        buildURL(`${url}/${id}`, o),
        options,
      ),
  };
};

export { factory };
